<template>
  <div id="app">
    <div id="wrapper" class="home-page">
      <!-- start header -->
      <header>
        <div class="navbar navbar-default navbar-static-top">
          <div class="container">
            <div class="navbar-header">
              <button
                type="button"
                class="navbar-toggle"
                data-toggle="collapse"
                data-target=".navbar-collapse"
              >
                <span class="icon-bar"/>
                <span class="icon-bar"/>
                <span class="icon-bar"/>
              </button>
              <a class="navbar-brand" href="/">
                <img src="./assets/images/logo.png" alt="logo">
              </a>
            </div>
            <div class="navbar-collapse collapse">
              <ul class="nav navbar-nav">
                <li
                  v-for="(item, index) in nav"
                  :key="index"
                  :class="{'dropdown':item.sub,'active':$route.name?$route.name.split('-')[0]==item.name:false}"
                >
                  <a
                    href="javascript:;"
                    v-if="item.sub"
                    data-toggle="dropdown"
                    class="dropdown-toggle"
                  >
                    {{ $t(item.name,"nav") }}
                    <b class="caret" v-if="item.sub"/>
                  </a>
                  <router-link :to="{name:item.name}" v-else>{{ $t(item.name,"nav") }}</router-link>
                  <ul class="dropdown-menu" v-if="item.sub">
                    <li v-for="(sub, subIndex) in $data[item.name]" :key="subIndex">
                      <router-link
                        v-if="sub.name=='sensing'"
                        :to="{name:'technology-sensing'}"
                      >{{ $t(sub.name,"nav") }}</router-link>
                      <router-link
                        v-else
                        :to="{name:item.name,params:{sub:sub.name}}"
                      >{{ $t(sub.name,"nav") }}</router-link>
                    </li>
                  </ul>
                </li>
                <li class="dropdown" v-if="lang.local=='zh'">
                  <a href="javascript:;" data-toggle="dropdown" class="dropdown-toggle">
                    <i class="site-icon icon-lang icon-lang-zh"/>
                    中文
                    <b class="caret"/>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a href="javascript:;" @click="lang.changeLang('jp')">
                        <i class="site-icon icon-lang icon-lang-jp"/>
                        日本語
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown" v-else>
                  <a href="javascript:;" data-toggle="dropdown" class="dropdown-toggle">
                    <i class="site-icon icon-lang icon-lang-jp"/>
                    日本語
                    <b class="caret"/>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a href="javascript:;" @click="lang.changeLang('zh')">
                        <i class="site-icon icon-lang icon-lang-zh"/>
                        中文
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <router-view/>
      <footer>
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="widget">
                <h5 class="widgetheading">{{ $t("title","contact") }}</h5>
                <address>
                  <strong>{{ $t("address_title","contact") }}</strong>
                  <br>
                  {{ $t("address","contact") }}
                </address>
                <p>
                  <span>TEL: +86 21 57741131</span>
                  <br>
                  <span>FAX: +86 21 57740636</span>
                  <br>E-mail : shbanjing@shsakai.com
                </p>
              </div>
            </div>
            <div class="col-md-2">
              <div class="widget">
                <h5 class="widgetheading">{{ $t("title","quick_link") }}</h5>
                <ul class="link-list">
                  <li v-for="(item, index) in quick_link" :key="index">
                    <router-link :to="{name:item.name}">{{ $t(item.name,"nav") }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-2">
              <div class="widget">
                <h5 class="widgetheading">{{ $t("category","nav") }}</h5>
                <ul class="link-list">
                  <li v-for="(item, index) in category" :key="index">
                    <router-link
                      :to="{name:'category',params:{sub:item.name}}"
                    >{{ $t(item.name,"nav") }}</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="widget">
                <h5 class="widgetheading">{{ $t("technology","nav") }}</h5>
                <div class="col-xs-5" style="padding-left:0">
                  <ul class="link-list">
                    <li v-for="(item, index) in technology.slice(0,4)" :key="index">
                      <router-link
                        :to="{name:'technology',params:{sub:item.name}}"
                      >{{ $t(item.name,"nav") }}</router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-xs-5" style="padding-left:0">
                  <ul class="link-list">
                    <li v-for="(item, index) in technology.slice(4,8)" :key="index">
                      <router-link
                        v-if="item.name=='sensing'"
                        :to="{name:'technology-sensing'}"
                      >{{ $t(item.name,"nav") }}</router-link>
                      <router-link
                        v-else
                        :to="{name:'technology',params:{sub:item.name}}"
                      >{{ $t(item.name,"nav") }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div style="text-align:center;margin:0 auto; padding:20px 0; line-height:1.8">
                <a
                  target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702005097"
                  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
                >
                  <p style="float:left;height:20px;line-height:2;color:#939393;">
                    <span style="float:left; margin-right:10px">上海坂井塑料成形有限公司</span>
                    <img src="./assets/images/ghs.png" style="float:left; margin-right:10px;">
                    <span style="float:left; margin-right:10px">沪公网安备 31011702005097号</span>
                  </p>
                </a>
                <a
                  target="_blank"
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
                >
                  <p style="float:left;height:20px;line-height:2;color:#939393;">
                    <span style="float:left; margin-right:10px">沪ICP备2021027563号</span>
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <a href="#" class="scrollup">
      <i class="fa fa-angle-up active"/>
    </a>
  </div>
</template>
<script>
import lang from "./helper/lang.js";

export default {
  name: "App",
  data() {
    return {
      lang,
      nav: [
        { name: "home" },
        { name: "commitment" },
        { name: "development" },
        {
          name: "quality"
        },
        {
          name: "category",
          sub: true
        },
        {
          name: "technology",
          sub: true
        },
        { name: "cooperative" },
        { name: "contact" }
      ],
      technology: [
        { name: "sheet_metal_forming" },
        { name: "welding" },
        { name: "forming" },
        { name: "packaging" },
        { name: "sheet_metal" },
        { name: "mould" },
        { name: "production" },
        { name: "sensing" }
      ],
      quality: [
        { name: "policy" },
        { name: "target" },
        { name: "authentication" }
      ],
      category: [
        { name: "housing" },
        { name: "daily" },
        { name: "kitchen" },
        { name: "shower" },
        { name: "electric" },
        { name: "construction" }
      ],
      quick_link: [
        { name: "commitment" },
        { name: "development" },
        { name: "quality" },
        { name: "cooperative" },
        { name: "contact" }
      ]
    };
  },
  updated() {
    window.hideNav();
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.site-icon {
  position: relative;
  display: inline-block;
  &:after {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    content: "";
    display: inline-block;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.icon-lang {
  width: 18px;
  height: 12px;
  vertical-align: middle;
  top: -2px;
}
.icon-lang-zh {
  &::after {
    background-image: url("./assets/images/lang/zh-cn.png");
  }
}
.icon-lang-jp {
  &::after {
    border: 1px solid #999;
    background-image: url("./assets/images/lang/jp.png");
  }
}

header .nav li .dropdown-menu {
  min-width: 120px;
}
</style>
